export default "__VITE_ASSET__Cct5R_VX__"